require(['jquery', 'uitk_i18n', 'handlebars.runtime'], function ($, I18n, hbRuntime) {

    var hb = hbRuntime.default;
    
    // register an empty i18nJs helper:
    hb.registerHelper('i18nJs', function (arguments) {
        if (arguments.length > 1) {
            I18n.locale=arguments[0];
        }
        return '';
    });

    // redirect i18n helper to i18n.js:
    hb.registerHelper('i18n', function () {
        var key = arguments[0],
            i18nOpts = {},
            len = arguments.length - 1,  options = arguments[len];
        for(var i = 1; i < len; i++) {
            i18nOpts['arg' + (i - 1)] = arguments[i];
        }

        i18nOpts.locale = options.hash.locale;
        return I18n.t(key, i18nOpts);
    });

    // The compress helper strips out whitespace
    hb.registerHelper('compress', function(options) {
        var html = options.fn(this);
        html = html.replace(/>\s+</g, "><"); // Remove whitespace between tags
        return html;
    });

    // Compares two variables to determine if localization is required.
    // Original source http://doginthehat.com.au/2012/02/comparison-block-helper-for-hb-templates/
    // Edited CSE Expedia 2014/2015 E. C.
    // TODO This logic should all be moved to the typeahead script when possible.

    hb.registerHelper('compare', function(lvalue, rvalue, options) {

        // NOTE: navigator.language approach doesn't work well
        // Doesn't return proper results on Chrome, which returns the language of the build of the browser,
        // instead of the language setting in the browser. Tested and verified.
        // http://stackoverflow.com/questions/1043339/javascript-for-detecting-browser-language-preference
        // var userLang = window.navigator.language || window.navigator.userLanguage;
        // console.log('language from browser prefs: ' + userLang);

        var htmlLang,
            localeLang = $('#typeahead-categorized').attr('data-locale'),
            myLocale = 'en_US';

        // localeLang is kept for backwards compatibility
        if(typeof localeLang !== 'undefined'){
            myLocale = localeLang;
        }else{
            htmlLang = $('html').attr('data-language');
            if(typeof htmlLang !== 'undefined'){
                myLocale = htmlLang;
            }
        }

        if(typeof myLocale !== 'undefined'){
            if ((myLocale !== 'en-US' && myLocale != 'en' && myLocale != "EN" && myLocale != "en-us" && myLocale != "en_us" && myLocale != "en_US") && (lvalue == rvalue)) {
                // this is a string that will cause compare to evaluate to
                // false and the template will render the i18n value
                rvalue = 'this will evaluate to false';
            } else {
                // this will evaluate to true
                rvalue = lvalue;
            }
        } else {
            rvalue = 'true';
            lvalue = 'true';
        }

        if (arguments.length < 3)
            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");

        operator = options.hash.operator || "==";

        var operators = {
            '==':       function(l,r) { return l == r; },
            '===':      function(l,r) { return l === r; },
            '!=':       function(l,r) { return l != r; },
            '<':        function(l,r) { return l < r; },
            '>':        function(l,r) { return l > r; },
            '<=':       function(l,r) { return l <= r; },
            '>=':       function(l,r) { return l >= r; },
            'typeof':   function(l,r) { return typeof l == r; }
        }

        if (!operators[operator])
            throw new Error("Handlerbars Helper 'compare' doesn't know the operator "+operator);

        var result = operators[operator](lvalue,rvalue);

        if( result ) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    // The category helper was written to translate and localize category names on the typeahead component
    // as presently we don't have the ability to update the typeahead script so the logic is here.
    // NOTE: This helper can be extended to handle a wide range of values by passing in the categories and translatedCategories arrays,
    // or to simply compare two variables.
    // TODO This logic should all be moved to the typeahead script when possible.

    hb.registerHelper('category', function(categoryName) {

        var categories = ['Airports','Region/City','Attractions','Hotels','Address','Train Station','Metro Station'],
            genericCategories = ['airport','city','attraction','hotel','address','trainstation','metrostation'],
            translated = '',
            indexFlag,

            htmlLang,
            localeLang = $('#typeahead-categorized').attr('data-locale'),
            myLocale = 'en_US';


        // localeLang is kept for backwards compatibility
        if(typeof localeLang !== 'undefined'){
            myLocale = localeLang;
        }else{
            htmlLang = $('html').attr('data-language');
            if(typeof htmlLang !== 'undefined'){
                myLocale = htmlLang;
            }
        }

        indexFlag = $.inArray(categoryName,categories);

        if((typeof myLocale) != 'undefined') {

            if ((myLocale != 'en-US' && myLocale != 'en' && myLocale != "EN" && myLocale != "en-us" && myLocale != "en_us" && myLocale != "en_US") && (indexFlag != -1)) {
                // translate the string
                translated = I18n.t(genericCategories[indexFlag]);
                return translated;

            } else {
                // no need to translate
                translated = categoryName;
                return translated;
            }
        } else {
            // if locale not set, pass through the value of categoryName.
            // this supports default and custom strings
            translated = categoryName;
            return translated;
        }

    });

    return hb;
});
